import type { Uuid } from '@common/types';

export type SelectedEntity = {
    entityType: ESelectedEntityType;
    entityId?: Uuid;
    entityStep?: string;
    showSettings?: boolean;
};

export enum ESelectedEntityType {
    block = 'block',
    specificBlock = 'specificBlock',
    zeroBlock = 'zeroBlock',
    specificSection = 'specificSection',
    column = 'column',
    grid = 'grid',
    tab = 'tab',
    widget = 'widget',
    theme = 'theme',
}

export enum PreviewMode {
    mobile = 'mobile',
    tablet = 'tablet',
    desktop = 'desktop',
}

export enum DeviceMode {
    mobile = 'mobile',
    tablet = 'tablet',
    desktop = 'desktop',
}

export type DrawerState = {
    drawerType: EDrawerType;
    blockIndex?: number;
};

export enum EDrawerType {
    block = 'block',
    page = 'page',
    navigation = 'navigation',
    aiChat = 'ai_chat',
}

export type PanelPosition = {
    x: number;
    y: number;
};
